import { useState, useEffect, useMemo } from "react";
import { supportLanguages } from "views/customer/main/variables/data";

export const useTargetLanguages = (selectedProject: any) => {
  const [selectedTargetLanguages, setSelectedTargetLanguages] = useState<string[]>([]);

  const orderTargetLanguages = useMemo(() => {
    const translated_to = selectedProject?.order?.translated_to || "";
    return String(translated_to)
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }, [selectedProject]);

  const availableTargetLanguages = useMemo(() => {
    const list: string[] = [];
    const seen = new Set<string>();
    const pushUnique = (lang?: string) => {
      const trimmed = String(lang || "").trim();
      if (!trimmed || seen.has(trimmed)) return;
      seen.add(trimmed);
      list.push(trimmed);
    };

    orderTargetLanguages.forEach((lang: string) => pushUnique(lang));
    (supportLanguages || []).forEach((lang: string) => pushUnique(lang));

    return list;
  }, [orderTargetLanguages]);

  const targetLanguageButtonLabel = useMemo(() => {
    if (selectedTargetLanguages.length === 0) return "None";
    if (selectedTargetLanguages.length === availableTargetLanguages.length) return "All";

    const preview = selectedTargetLanguages.slice(0, 2);
    const remaining = selectedTargetLanguages.length - preview.length;
    return remaining > 0
      ? `${preview.join(", ")} +${remaining}`
      : preview.join(", ");
  }, [availableTargetLanguages.length, selectedTargetLanguages]);

  const toggleTargetLanguage = (lang: string) => {
    setSelectedTargetLanguages((prev) => {
      const next = new Set(prev);
      if (next.has(lang)) {
        next.delete(lang);
      } else {
        next.add(lang);
      }

      return availableTargetLanguages.filter((it) => next.has(it));
    });
  };

  useEffect(() => {
    setSelectedTargetLanguages(orderTargetLanguages);
  }, [orderTargetLanguages]);

  return {
    selectedTargetLanguages,
    availableTargetLanguages,
    orderTargetLanguages,
    targetLanguageButtonLabel,
    toggleTargetLanguage,
    setSelectedTargetLanguages
  };
};
